import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FaEdit, FaCheck } from "react-icons/fa";
import { LanguageApi } from "../../../../App/api/setting";
import { useFetchAll } from "../../../../custom/FetchApiHook";

const Modal = ({ isVisible, onClose, onSubmit }) => {
  const [keyName, setKeyName] = useState("");
  const [defaultValue, setDefaultValue] = useState("");

  const handleSubmit = () => {
    if (keyName && defaultValue) {
      onSubmit({ keyName, defaultValue });
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <h2 className="text-xl font-semibold mb-4">Add New Key</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Key Name
          </label>
          <InputText
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
            value={keyName}
            onChange={(e) => setKeyName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Default Value
          </label>
          <InputText
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
            value={defaultValue}
            onChange={(e) => setDefaultValue(e.target.value)}
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const ViewTranslation = ({
  data = [],
  onSubmit,
  userRole,
  isModalVisible,
  setIsModalVisible,
}) => {
  const { value } = useFetchAll(() =>
    LanguageApi.createTranslation.getAllTranslation()
  );

  const columns = (data || []).map((item) => ({
    field: item.code,
    header: item.name,
    code: item.code,
  }));

  const initialRows = [
    { key: "Dashboard" },
    { key: "Setting" },
    { key: "Order" },
  ];

  const translationValue = value?.data;
  // console.log("translationValue", translationValue);

  // console.log("columsn", columns);

  const headers = new Set(columns.map((item) => item.header));

  // Filter `data2` to find items where `key` does not match any `header`
  const unmatched = translationValue?.filter((item) => !headers.has(item.key));

  // console.log("unmatched,", unmatched);

  columns.forEach((col) => {
    let i = 0;
    initialRows.forEach((row) => {
      row[col.field] = i++;
    });
  });

  const [rows, setRows] = useState(initialRows);
  const [editingCell, setEditingCell] = useState({
    rowIndex: null,
    colField: null,
  });
  const [cellValues, setCellValues] = useState(
    initialRows.reduce((acc, row) => {
      columns.forEach((col) => {
        acc[`${row.key}-${col.field}`] = row[col.field] || "";
      });
      return acc;
    }, {})
  );

  const handleEditClick = (rowIndex, field) => {
    setEditingCell({ rowIndex, colField: field });
  };

  const handleInputChange = (rowIndex, field, value) => {
    setCellValues((prev) => ({
      ...prev,
      [`${rows[rowIndex].key}-${field}`]: value,
    }));
  };

  const handleDoneClick = async (rowIndex, field) => {
    const updatedRow = {
      ...rows[rowIndex],
      [field]: cellValues[`${rows[rowIndex].key}-${field}`],
    };
    const updatedRows = rows.map((row, index) =>
      index === rowIndex ? updatedRow : row
    );

    // console.log("user role", userRole);
    const id = userRole.toString();

    // console.log("type of id", typeof id);

    const newTranslation = {
      user_role: userRole,
      key: updatedRow.key,
      translations: {
        en: updatedRow.key,
        [field]: updatedRow[field],
      },
    };

    try {
      await LanguageApi.createTranslation.createLagnuageTranslation(
        newTranslation
      );
    } catch (error) {
      if (error?.error?.code === 11000) {
        try {
          await LanguageApi.createTranslation.updateTranslation(newTranslation);
          // console.log("upadated succesfylly");
        } catch (error) {
          // console.log("error occurd while upadte", error);
        }
      }
      // console.log("Error updating translation:", error);
    }

    setRows(updatedRows);
    setEditingCell({ rowIndex: null, colField: null });
  };
  const onCellEditComplete = (e) => {
    let { rowData, newValue, field } = e;
    rowData[field] = newValue;
    setCellValues((prev) => ({
      ...prev,
      [`${rowData.key}-${field}`]: newValue,
    }));
  };
  const cellEditor = (options) => {
    const { rowIndex, field, value } = options;
    const isEditing =
      editingCell.rowIndex === rowIndex && editingCell.colField === field;
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {isEditing ? (
          <>
            <InputText
              type="text"
              value={cellValues[`${rows[rowIndex].key}-${field}`] || ""}
              onChange={(e) =>
                handleInputChange(rowIndex, field, e.target.value)
              }
            />
            <FaCheck
              style={{ cursor: "pointer", marginLeft: "8px" }}
              onClick={() => handleDoneClick(rowIndex, field)}
            />
          </>
        ) : (
          <>
            <span>{cellValues[`${rows[rowIndex].key}-${field}`] || ""}</span>
            <FaEdit
              style={{ cursor: "pointer", marginLeft: "8px" }}
              onClick={() => handleEditClick(rowIndex, field)}
            />
          </>
        )}
      </div>
    );
  };

  const handleModalSubmit = ({ keyName, defaultValue }) => {
    const newKey = keyName || `NewKey_${rows.length + 1}`;
    const newRow = { key: newKey };

    columns.forEach((col) => {
      newRow[col.field] = defaultValue || "";
    });

    setRows((prevRows) => [...prevRows, newRow]);

    setEditingCell({
      rowIndex: rows.length,
      colField: columns[0].field,
    });
  };

  return (
    <div>
      <DataTable
        value={rows}
        responsiveLayout="scroll"
        editMode="cell"
        onCellEditComplete={onCellEditComplete}
        style={{ borderCollapse: "collapse" }}
      >
        <Column
          field="key"
          header="Key"
          style={{ width: "150px", border: "1px solid #ccc" }}
        />
        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            editor={cellEditor}
            style={{ width: "150px", border: "1px solid #ccc" }}
          />
        ))}
      </DataTable>
      <Modal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onSubmit={handleModalSubmit}
      />
    </div>
  );
};

export default ViewTranslation;
